var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3324 1.12716C18.0005 0.438339 17.2991 0 16.5289 0C15.7587 0 15.0636 0.438339 14.7255 1.12716L10.699 9.41176L1.70679 10.7393C0.955356 10.852 0.329158 11.378 0.0974644 12.0982C-0.134229 12.8183 0.0536303 13.6136 0.592161 14.1458L7.11715 20.6019L5.5767 29.7256C5.45146 30.4771 5.76456 31.241 6.3845 31.6856C7.00443 32.1302 7.82475 32.1866 8.50105 31.8297L16.5352 27.5402L24.5693 31.8297C25.2456 32.1866 26.0659 32.1365 26.6859 31.6856C27.3058 31.2348 27.6189 30.4771 27.4937 29.7256L25.9469 20.6019L32.4719 14.1458C33.0105 13.6136 33.2046 12.8183 32.9666 12.0982C32.7287 11.378 32.1087 10.852 31.3573 10.7393L22.3588 9.41176L18.3324 1.12716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/ic_star.9190db34dc1e776077c74d34f17953f2.svg";
export { ForwardRef as ReactComponent };